import clsx from 'clsx';
import { IMAGES } from 'src/assets';
import { UserAvatarProps } from './userAvatar.types';
import { Image } from './userAvatar.styles';
import { getUserNameInitialLetters } from './utils';

const UserAvatar = ({ src, alt, small, className, onClick }: UserAvatarProps) => {
  const showTextAvatar = !src && alt;

  if (showTextAvatar) {
    return (
      <Image
        as="div"
        title={alt}
        small={Boolean(small)}
        className={clsx(
          '_bg-gray-200 _text-gray-700 _d-flex _justify-content-center _align-items-center _rounded-circle',
          className
        )}
        translate="no"
        onClick={onClick}
      >
        {getUserNameInitialLetters(alt)}
      </Image>
    );
  }

  return (
    <Image
      src={src || IMAGES.AVATAR_OWNER_DEFAULT}
      alt={alt}
      className={clsx('_rounded-circle', className)}
      small={Boolean(small)}
      loading="lazy"
      onClick={onClick}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = IMAGES.AVATAR_OWNER_DEFAULT;
      }}
    />
  );
};

export default UserAvatar;
